export const SEGMENTS = [
  { value: "driver", label: "I'm a Driver" },
  { value: "owner", label: "I'm a Driver / Owner Operator" },
  { value: "carrier", label: "I'm a Carrier / Fleet" },
  { value: "broker", label: "I'm a Broker" },
  { value: "need_driver", label: "I Need a Driver" },
  { value: "rv_service", label: "I Need RV Rescue or Delivery" },
  { value: "rv_dealer", label: "I'm an RV Dealer / Fleet" },
];

export const SEGMENT_LABELS = SEGMENTS.reduce((acc, s) => ({ ...acc, [s.value]: s.label }), {});

export const NEEDS_COMPANY = ["carrier", "broker", "need_driver", "rv_dealer"];
export const NEEDS_FLEET_SIZE = ["carrier", "need_driver", "rv_dealer"];
export const NEEDS_USDOT = ["need_driver"];
export const NEEDS_OPERATING_AREA = ["need_driver"];

export const COMPANY_LABEL = {
  carrier: "Company / fleet name",
  broker: "Brokerage name",
  need_driver: "Company name (if applicable)",
  rv_dealer: "Dealership / fleet name",
};
